import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductMovementService {

  constructor(private httpClientService: HttpClientService) { }

  async createProductMovement(count, productId, warehouseId) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.ProductMovement
    }, {
      productId: productId,
      productCount: count,
      warehouseId: warehouseId
    });
    return await firstValueFrom(observable);
  }

  async updateProductMovement(id,count,warehouseId){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.ProductMovement
    },{
      productMovementId:id,
      productCount:count,
      warehouseId:warehouseId
    });
    return await firstValueFrom(observable);
  }
}
